import React from "react";
import {
  Card,
  CardContent,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(() => ({
  title: {
    fontSize: 16,
    fontWeight: 600,
    marginBottom: 12,
  },
  note: {
    marginTop: 12,
    fontSize: 12,
    color: "#666",
  },
  tableCell: {
    borderBottom: "1px solid #efefef",
  },
}));

const BudgetByBoostTable = ({ rows }) => {
  const classes = useStyles();

  return (
    <Card>
      <CardContent>
        <Typography className={classes.title}>ブースト別 撮影集計</Typography>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell className={classes.tableCell}>イベント</TableCell>
              <TableCell className={classes.tableCell} align="right">対象電柱</TableCell>
              <TableCell className={classes.tableCell} align="right">撮影数</TableCell>
              <TableCell className={classes.tableCell} align="right">排出金額</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((row) => (
              <TableRow key={row.name}>
                <TableCell className={classes.tableCell}>{row.name}</TableCell>
                <TableCell className={classes.tableCell} align="right">{row.target}</TableCell>
                <TableCell className={classes.tableCell} align="right">{row.shots}</TableCell>
                <TableCell className={classes.tableCell} align="right">{row.payout}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
        <Typography className={classes.note}>
          ※ 対象電柱数はイベント開始時点で未撮影かつ報酬残ありの電柱のみを計上
        </Typography>
      </CardContent>
    </Card>
  );
};

export default BudgetByBoostTable;
